<template>
    <div class="employee-tab-inner">    

        <div class="">
            <div v-if="em_reg_settlement_list.length>0">
                <common-list  :pageurl="this.$api_url"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="settlement_list_key" :company_options="company_options" :employees="em_reg_settlement_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="settlementListReturn"></common-list>
            </div>
            <div v-else>

                <div v-if="settlement_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no employee to show.
                </div>
                
            </div>
        </div>   
	
		<b-modal id="unsettle-modal" title="Are you sure you want to unsettle this process ?" hide-footer> 
			<br />
			<div style="height: 10px;clear:both;"> &nbsp;</div>
			<a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="unsettlePF(unsettle_pf_id)">Unsettle <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
			&nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unsettle-modal')">Cancel</a>
			<div style="height: 5px;clear:both;"> &nbsp;</div>
		</b-modal>

        <div>

            
            <b-modal id="delete-modal-settlement" title="Are you sure you want to delete this Application ?" hide-footer> 
                <br />
                <div style="height: 10px;clear:both;"> &nbsp;</div>
                <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteSettlement()">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/images/loading.gif'" width="20"></span></a>
                &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal-settlement')">Cancel</a>
                <div style="height: 5px;clear:both;"> &nbsp;</div>
            </b-modal>

        </div>

        <pf-settlement-form :employee_id ="curr_emp_id" :employee_name="curr_emp_name" :pageurl="pageurl" :settlement_id="settlement_id" :settlement_data="settlement_fdata" :key="settle_form_key" ></pf-settlement-form>
		
    </div>
</template>


<script>
    
    export default{ 
        
        mounted() {
            
            
        },
        props: ['flg','pageurl'],
        components: {
           
        },
        data(){            
           
        
            return {
                
                showoverlaymodal:false,
                settle_form_key:0,
                settlement_id:0,
                settlement_fdata : {
                  employee_id:0, 
                  id: 0,
                  settlement_amount: 0,
                  settlement_date: null, 
                  settlement_details:'',
                  settlement_status: null,  
                  settlement_type:null,
                  salary_contribution_employer:0,
                  salary_contribution_employee:0,
                  profit_contribution_employer:0,
                  profit_contribution_employee:0,
                  forfeiture_contribution_employer:0, 
                  forfeiture_contribution_employee:0,                           
                },
                settlement_loader:true,
                settlement_list:[],
                settlement_list_key:0,
                loading:'',
                curr_update_employee:'',
                min_date:'',
                curr_approve_date:"",
                is_n_pf:1,
                /**Child Component property data */

                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                em_reg_settlement_list:[],  /* Data List */
                default_column:['name','email','jobposition'], /* Default Column List */
                appended_column:[
                     
                    { value: "status", text: "Status",type: "text"},
                    { value: "settlement_type", text: "Settlement Type",type: "text"},
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],

                /***Child Component property data */
                date_min:'',

                unsettle_pf_id:0,
                approvepass: '',
                incorrectpass: '',
                payrun_delete_msg:'',

                curr_emp_name: '',
                curr_emp_id: 0,
                curr_emp_pf_total: 0,
                curr_emp_loan_total: 0,
                curr_emp_pf_total_adjusted:0,


                curr_emp_salary_fund: 0,
                curr_emp_salary_fund_employer: 0,
                curr_emp_salary_fund_employee: 0,
                curr_emp_profit_fund: 0,
                curr_emp_profit_fund_employer: 0,
                curr_emp_profit_fund_employee: 0,
                curr_emp_forfeiture_fund: 0,
                curr_emp_forfeiture_fund_employer: 0,
                curr_emp_forfeiture_fund_employee: 0,

                curr_emp_settle_balance: 0,
                curr_emp_settle_balance_show: 0,

                disable_amount:false,
                pf_from_disable:false,
                action_type:0,
                settlement_id:0,
            


    
            }
        },
        methods:{
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
            settlementListReturn: function(data)
            {
                if(data.action_id==1 || data.action_id==2)
                {
                    this.action_type = data.action_id;
                    var item  = this.em_reg_settlement_list.find(item => item.id === data.id); 

                    this.settlement_id = item.id; 
                    this.settlement_fdata.id = item.id;
                    this.settlement_fdata.employee_id = item.employee_id;
                    this.settlement_fdata.settlement_date = item.settlement_date;
                    this.settlement_fdata.settlement_details = item.details;
                    this.settlement_fdata.settlement_status = item.status;
                    this.settlement_fdata.settlement_type = item.settlement_type;
                    this.settlement_fdata.salary_contribution_employer = item.company_pf;
                    this.settlement_fdata.salary_contribution_employee = item.employee_pf;
                    this.settlement_fdata.profit_contribution_employer = item.company_profit;
                    this.settlement_fdata.profit_contribution_employee = item.employee_profit;
                    this.settlement_fdata.forfeiture_contribution_employer = item.company_forfeiture;
                    this.settlement_fdata.forfeiture_contribution_employee = item.employee_forfeiture;
                    this.curr_emp_name = item.name;
                    this.curr_emp_id = item.employee_id;
                    this.curr_approve_date=item.pf_end;
                    this.settle_form_key += 1;  
                    // console.log('this.settlement_fdata.salary_contribution_employer');
                    // console.log(this.settlement_fdata.salary_contribution_employer);
                    

                 
                }
                if(data.action_id==3) 
                {
                    this.settlement_id = data.id;
                    this.$bvModal.show('delete-modal-settlement'); 
                }
            },
            
            toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return 0;
            },
            getLastPayrun(flg)
            {

                if(0)
                {
                    var current_date = new Date();
                    this.date_min = current_date;
                    
                }
                else
                {
                    let formData = new FormData();
                    
                    axios.post(this.$api_url + '/pf/last-payrun', formData)
                    .then(function(response){
                    
                        var m_names = ['January', 'February', 'March', 
                            'April', 'May', 'June', 'July', 
                            'August', 'September', 'October', 'November', 'December'];
                        var all_months = [];
                        var start_month = response.data;
                        const str_month_arr = start_month.split("-");
                        var yr1   = parseInt(str_month_arr[1]);
                        var mt  = str_month_arr[0]; 
                        var mon1 = m_names.indexOf(mt);
                        var dt1   = 1;
                        var current_date = new Date();
                        var d1 = new Date(yr1, mon1);
                        d1.setMonth(d1.getMonth() + 1);
                        this.date_min = d1;
                    
                    }.bind(this));
                }

                
            },
            
            deleteSettlement: function()
            {
                let settlement_id = this.settlement_id;
                this.settlement_id = 0;
                let currentObj = this;
                currentObj.showoverlaymodal = true;

                let formData = new FormData();
                formData.append('id', settlement_id);
                var url = this.$api_url+'/pf/settlement-approval/delete';
                axios.post(url, formData)
                .then(function(response){

                    if(response.data.success){
                        this.$bvToast.toast("Settlement successfully deleted", {title: 'Success',variant: 'success',solid: true});

                    }else{ 
                        if(response.data.message){
                            this.$bvToast.toast(response.data.message, { 
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        }else{
                            this.$bvToast.toast("Server error!!!", {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    
                    } 
                    currentObj.pfSettlementList();
                    currentObj.showoverlaymodal = false;
                    currentObj.$bvModal.hide('delete-modal-settlement');
                }.bind(this));
                
            },
           
            pfSettlementList: function(index_name='employee_dropdown')
            {
                this.settlement_list = [];
                this.em_reg_settlement_list = [];
               
                let currentObj = this;
                currentObj.settlement_loader = true;
                axios.get(this.$api_url+'/pf/settlement/pending-list' , {
                    params: {
								  settlement_list: 1
							}
    
                }).then(function(response){

                   
                

                //this.settlement_list = [];

                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.settlement_list = response.data.employee_data;

                    /* Assingning the list */ 
                    this.settlement_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    this.company_options =  response.data.options;
                }
                if (typeof response.data.options !== 'undefined')
                {
                
                }
                

                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                

                if(this.settlement_list.length > 0 )
                {
                        let emp_ids = []; 
                        this.settlement_list.forEach(pelement => {
                            
                            let dops = []; 

                            let awating = []; 

                             
                            let ii = 0; 
                
                            if(pelement.employee_id > 0)
                            {
                                // if(!emp_ids.includes(pelement.employee_id))
                                // {
                                   
                                    

                                // }
                                
                                emp_ids.push(pelement.employee_id);

                                if(this.$acl['pf/leaverlist'] > 1 )
                                {
                                    dops = dops.concat([{ label: 'Details' , value: 1 }]);
                                    dops = dops.concat([{ label: 'Delete' , value: 3 }]);

                                   
                                }
                                pelement.actions = dops; 
                                pelement.pf_total = this.formatMoney(pelement.pf_total);
                                
                                
                                if(pelement.pf_end == '0000-00-00' || pelement.pf_end == '' || pelement.last_payslip == null)
                                {
                                    pelement.pf_end ='';
                                
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                }
                                else
                                { 
                                    
                                    this.em_reg_settlement_list = this.em_reg_settlement_list.concat(pelement);
                                    

                                    ii++;

                                    
                                        
                                }

                                // console.log(pelement.employee_id);
                            }
                            else
                            {
                               
                            }
                        });

                    
                }
                else
                {
                    this.blankmsg = "No settlement found";
                }
                
                // console.log(this.em_reg_settlement_list);
                //this.reg_custom_list = this.reg_tmp_custom_list;
                this.settlement_list_key = this.settlement_list_key + 1;
                
                currentObj.settlement_loader = false;
                }.bind(this)).catch(function (error){
                    currentObj.settlement_loader = false;
                    // console.log(error)
                });
            },
            
        },
        created: function(){
          this.pfSettlementList();
        },
        computed: 
        {
         
        }
    }
</script>

